import http from './httpService';

const endPoint = "/ChangeLog";

export function getChangeLogs({ entityName, fieldName, keys, take, skip }) {
    return http.post(endPoint, { entityName, fieldName, keys, take, skip });
}

const characteristicsService = { getChangeLogs };

export default characteristicsService;